import Tooltip from '@creditflowresearch/uilib/Tooltip';
import type { ICountry, IRegion } from '@/creditflowresearch/domain/vo/IDeal';

interface IRegionProps {
  region?: IRegion,
  country?: ICountry,
}

export const Region = ({ region, country }: IRegionProps) => {
  if (!region) {
    return '-';
  }

  return (
    <Tooltip content={ `Issuer Domicile: ${ country?.name ?? region.name }` }>
      { region.abbreviation }
    </Tooltip>
  );
};
